// Resumable onboarding (web): the step and picks so far, saved per user in
// localStorage so a reload / closed tab does not lose them. Same rules as the
// mobile app (apps/mobile/src/utils/onboardingDraft.js): the server stays
// authoritative for completion, drafts from an incompatible onboarding version
// or older than 30 days are ignored, and the draft is removed once saved.
// Title selection is optional: a draft on genres with no titles resumes there.
import { ONBOARDING_DRAFT_VERSIONS, ONBOARDING_VERSION } from '@aluvo/constants/src/onboardingDiagnostics';
import { titleKey } from '@aluvo/constants/src/onboardingTitles';

const PREFIX = 'aluvo_onboarding_draft:';
const MAX_AGE_MS = 30 * 24 * 60 * 60 * 1000;

export function parseDraft(raw, { now = Date.now() } = {}) {
    let draft;
    try { draft = typeof raw === 'string' ? JSON.parse(raw) : raw; } catch { return null; }
    if (!draft || typeof draft !== 'object' || !ONBOARDING_DRAFT_VERSIONS.includes(draft.version)) return null;
    if (!Number.isFinite(draft.updatedAt) || now - draft.updatedAt > MAX_AGE_MS) return null;
    const seen = new Set();
    const titles = (Array.isArray(draft.titles) ? draft.titles : [])
        .filter((t) => t && (t.kind === 'movie' || t.kind === 'tv') && Number.isFinite(Number(t.tmdbId)))
        // Keyed by kind + TMDB id (older drafts keyed by the TMDB id alone).
        .map((t) => ({ id: titleKey(t.kind, t.tmdbId), tmdbId: Number(t.tmdbId), kind: t.kind, title: typeof t.title === 'string' ? t.title : '', posterUrl: typeof t.posterUrl === 'string' ? t.posterUrl : null }))
        .filter((t) => !seen.has(t.id) && seen.add(t.id))
        .slice(0, 100);
    const genreIds = (Array.isArray(draft.genreIds) ? draft.genreIds : []).filter(Number.isInteger).slice(0, 50);
    const step = [1, 2, 3].includes(draft.step) ? draft.step : 1;
    return { step, titles, genreIds };
}

export function loadOnboardingDraft(userId) {
    if (!userId) return null;
    try { return parseDraft(localStorage.getItem(`${PREFIX}${userId}`)); } catch { return null; }
}

export function saveOnboardingDraft(userId, { step, titles, genreIds }) {
    if (!userId) return;
    try {
        localStorage.setItem(`${PREFIX}${userId}`, JSON.stringify({ version: ONBOARDING_VERSION, step, titles, genreIds, updatedAt: Date.now() }));
    } catch { /* storage full / blocked */ }
}

export function clearOnboardingDraft(userId) {
    if (!userId) return;
    try { localStorage.removeItem(`${PREFIX}${userId}`); } catch { /* ignore */ }
}
